import format from 'date-fns/format';
import formatDuration from 'date-fns/formatDuration';
import intervalToDuration from 'date-fns/intervalToDuration';
import en from 'date-fns/locale/en-US';
import ja from 'date-fns/locale/ja';
import ko from 'date-fns/locale/ko';
import parse from 'date-fns/parse';
import startOfToday from 'date-fns/startOfToday';
import dayjs from 'dayjs';

// format 형식
// https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
export const DateFormat = {
  toString: (date: Date | number, formatStr: string) => {
    return format(date, formatStr);
  },
  toKoString: (date: Date | number, formatStr: string) => {
    return format(date, formatStr, { locale: ko });
  },
  parseYMD: (value: number) => {
    const year = Math.floor(value / 10000);
    const month = Math.floor((value % 10000) / 100) - 1;
    const day = value % 100;
    return new Date(year, month, day);
  },
  parseYMDHMS: (value: number) => {
    return new Date(value + 3240 * 10000).toISOString().replace(/T/, ' ').replace(/\..+/, '');
  },
  countDDay: (date: Date | number) => {
    const dateInNumber = typeof date === 'number' ? new Date(date) : date;
    const today = startOfToday();
    return Math.floor((dateInNumber.valueOf() - today.valueOf()) / (24 * 60 * 60 * 1000));
  },
  distance: (start: Date, end: Date, localeCode?: 'ko' | 'en' | 'ja') => {
    const locales = { ko, en, ja };
    return formatDuration(intervalToDuration({ start, end }), {
      locale: localeCode ? locales[localeCode] : ko,
    });
  },
};

export const parseDateYmd = (date_ymd: number) => parse(String(date_ymd), 'yyyyMMdd', new Date());

export const isBeforeToday = (date: Date | number) => dayjs().isBefore(date);

export const formatDateToMMDDdd = (timestamp?: number | null) => {
  return timestamp ? dayjs(timestamp).locale('ko').format('MM.DD(dd)') : '';
};
